import request from '@/plugins/request'
export const listRecords = (pageNum,pageSize,data) => {
  return request({
    url: `/afterSale/returnVisit/list/${pageNum}/${pageSize}`,
    method: 'POST',
    data
  })
}
export const importRecords = (data) => {
  return request({
    url: `/afterSale/returnVisit/import`,
    method: 'POST',
    data
  })
}
export const RecordsData = (data) => {
  return request({
    url: `/afterSale/returnVisit/data`,
    method: 'POST',
    data
  })
}
export const getTime = () => {
  return request({
    url: `/afterSale/returnVisit/getTime`,
    method: 'POST',
  })
}
